import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useLang } from "../i18n/LangContext";
import { roleHome } from "../lib/roleHome";

export function ProtectedRoute({ children, requireVerified = true, permission = null, roles = null }) {
  const { user, checked } = useAuth();
  const { t } = useLang();

  if (!checked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#090A0F] text-slate-400">
        {t("common.loading")}
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireVerified && !user.email_verified) return <Navigate to="/verify-email" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={roleHome(user)} replace />;
  if (permission && !user.permissions?.includes(permission)) return <Navigate to={roleHome(user)} replace />;
  return children;
}
